module.exports = __webpack_public_path__ + "img/Webinare_Bild_Final.1a22c9bd.jpg";